export default __webpack_public_path__ + "static/media/courseImage.051b9f79.png";